<template>
	<header id="header" class="fw5 relative overflow-hidden">
		<div :class="[ `container flex justify-between items-center`, $css(styles.container)]">
			<strong :class="[`logo db`, $css(styles.logo)]">
				<a class="db" href="https://cloudinary.com" target="_blank">
					<img src="../../assets/images/logo.svg" alt="Cloudinary"
						 :class="[`logo-img db`, $css(styles.logoImg)]">
					<img src="../../assets/images/logo-small.svg" alt="Cloudinary"
						 :class="[`logo-img-small dn`, $css(styles.logoImgSmall)]">
				</a>
			</strong>
			<strong class="title fw5 db">Upload Widget Demo</strong>
			<Button text="Sign Up Free" :styles="styles.button"
					@click.native="onSignUpClick"/>
		</div>
	</header>
</template>

<script>
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import Button from "./simple/Button.vue";

	function styles() {
		return this.$style({
			title: {
				...gimq(MQ_SIZES.M, {
					padding: "0 0 0 25px",
				}),
				...gimq(MQ_SIZES.S, {
					padding: "0",
				})
			},
			container: gimq(MQ_SIZES.M, {
				padding: "15px 18px",
			}),
			logo: gimq(MQ_SIZES.M, {
				width: "51px",
			}),
			logoImg: gimq(MQ_SIZES.M, {
				display: "none",
			}),
			logoImgSmall: gimq(MQ_SIZES.M, {
				display: "block",
			}),
			button: gimq([MQ_SIZES.M, {
					visibility: "hidden",
					opacity: "0",
				}],
				[MQ_SIZES.S, {
					display: "none",
				}])
		});
	}

	export default {
		name: "TopBar",
		components: {
			Button
		},
		computed: {
			styles
		},
		methods: {
			onSignUpClick() {
				window.open("https://cloudinary.com/users/register/free");
			}
		}
	}
</script>

<style scoped lang="scss">
	@import "../../assets/scss/_variables";

	#header {
		font-size: 18px;
		line-height: 26px;
		background: $blue;
		color: $white;
		min-height: 62px;

		.container {
			padding: 12px 22px;
		}

		.logo {
			width: 166px;
		}
	}
</style>
